import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Button,
    Badge,
    Spinner,
    Input,
    InputGroup,
    InputGroupText,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Table,
    FormGroup,
    Label
} from "reactstrap";
import { useAuth } from "../../Provider/AuthProvider";
import TableContainer from "../../Components/Common/TableContainer";

// Styles CSS pour le responsive
const responsiveStyles = `
@media (max-width: 1024px) {
    .page-content {
        padding: 0.5rem;
    }
    
    .card-body {
        padding: 1rem;
    }
    
    .table-responsive {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }
    
    .btn {
        padding: 0.5rem 0.75rem;
        font-size: 0.875rem;
    }
    
    .btn-sm {
        padding: 0.375rem 0.625rem;
    }
    
    button, 
    [role="button"],
    .cursor-pointer {
        min-height: 44px;
    }
    
    .modal-dialog {
        margin: 0.5rem;
    }
    
    .modal-content {
        max-height: calc(100vh - 1rem);
    }
    
    .modal-body {
        max-height: calc(100vh - 200px);
        overflow-y: auto;
    }
    
    input[type="number"] {
        font-size: 16px;
    }
    
    .overflow-auto {
        -webkit-overflow-scrolling: touch;
    }
    
    /* Masquer la vue desktop sur tablette et mobile */
    .desktop-view {
        display: none !important;
    }
    
    /* Afficher la vue mobile sur tablette et mobile */
    .mobile-view {
        display: block !important;
    }
    
    /* Afficher les filtres mobiles sur tablette et mobile */
    .desktop-filters {
        display: none !important;
    }
    
    .mobile-filters {
        display: block !important;
    }
    
    /* Pagination simplifiée pour tablette et mobile */
    .pagination-container {
        display: none !important;
    }
    
    .mobile-pagination-simple {
        display: flex !important;
    }
}

@media (min-width: 1025px) {
    .mobile-view {
        display: none !important;
    }
    
    .mobile-filters {
        display: none !important;
    }
    
    .desktop-filters {
        display: block !important;
    }
    
    .desktop-view {
        display: block !important;
    }
    
    .mobile-pagination-simple {
        display: none !important;
    }
    
    .pagination-container {
        display: block !important;
    }
}

/* Ajustement des filtres pour les résolutions 500px - 1024px - décaler vers le bas */
@media (min-width: 500px) and (max-width: 1024px) {
    .mobile-filters {
        margin-top: 2.5rem;
    }
    
    .mobile-filters .w-100.mb-2 {
        margin-top: 1.5rem;
        margin-bottom: 0.75rem !important;
    }
    
    .mobile-filters .border.rounded.p-3.bg-light {
        margin-top: 1.5rem;
        margin-bottom: 0.5rem;
    }
}

/* Ajustement spécifique pour les tablettes en orientation portrait */
@media (min-width: 768px) and (max-width: 1024px) {
    .mobile-filters {
        margin-top: 2rem;
    }
    
    .mobile-filters .btn-light {
        margin-bottom: 0.75rem !important;
    }
    
    /* Centrage des inputs dans le modal de réception pour tablette */
    .mobile-reception .reception-card .d-flex {
        justify-content: center;
    }
    
    .mobile-reception .reception-card .d-flex > div {
        max-width: 120px;
    }
    
    /* Centrage du résumé de réception pour tablette */
    .reception-modal .bg-light.rounded {
        text-align: center;
    }
    
    .reception-modal .d-flex.flex-column.flex-sm-row {
        justify-content: center !important;
        text-align: center;
    }
    
    .reception-modal .d-flex.flex-column.flex-sm-row > div {
        width: 100%;
        text-align: center;
    }
    
    /* Centrage de la pagination pour tablette */
    .mobile-pagination-simple {
        max-width: 375px;
        margin-left: auto;
        margin-right: auto;
        justify-content: center;
    }
    
    /* Centrage des cartes produit pour tablette */
    .mobile-view .card {
        max-width: 500px;
        margin-left: auto;
        margin-right: auto;
    }
    
    /* Centrage du bouton de filtres pour tablette */
    .mobile-filters .btn-light.w-100 {
        max-width: 300px;
        margin-left: auto;
        margin-right: auto;
        display: block;
    }
}

/* Ajustement pour les résolutions entre 500px et 767px */
@media (min-width: 500px) and (max-width: 767px) {
    .mobile-filters {
        margin-top: 1.75rem;
    }
    
    .mobile-filters .btn-light {
        margin-bottom: 0.5rem !important;
    }
}

/* Pour les écrans 1300px et plus - PAS DE SCROLL HORIZONTAL, exactement comme 1800px */
@media (min-width: 1300px) {
    .desktop-view .table-responsive {
        overflow-x: visible !important;
        overflow-y: visible !important;
    }
    
    .desktop-view .table-responsive table {
        width: 100% !important;
        min-width: 100% !important;
        table-layout: auto !important;
    }
    
    /* Aucune réduction de taille, tout est normal comme en 1800px */
    .desktop-view table th,
    .desktop-view table td {
        padding: 0.75rem !important;
        font-size: 0.875rem !important;
    }
    
    .desktop-view .btn-sm {
        padding: 0.375rem 0.75rem !important;
        font-size: 0.875rem !important;
    }
    
    .desktop-view .badge {
        font-size: 0.875rem !important;
        padding: 0.35rem 0.65rem !important;
    }
}

/* Pour les écrans entre 1025px et 1299px - scroll horizontal autorisé */
@media (min-width: 1025px) and (max-width: 1299px) {
    .desktop-view .table-responsive {
        overflow-x: auto !important;
    }
}

.mobile-filters .border {
    animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.cursor-pointer:active {
    transform: scale(0.98);
    transition: transform 0.1s;
}

::-webkit-scrollbar {
    width: 4px;
    height: 4px;
}

::-webkit-scrollbar-track {
    background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 2px;
}

::-webkit-scrollbar-thumb:hover {
    background: #555;
}

/* Styles pour les modals sans scroll horizontal */
.modal-body {
    overflow-x: hidden !important;
}

.modal-body .table-responsive {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}

.modal-body .table {
    margin-bottom: 0;
    min-width: auto;
}

@media (max-width: 1024px) {
    .modal-body .table th,
    .modal-body .table td {
        white-space: normal;
        word-break: break-word;
    }
    
    .modal-body input[type="number"] {
        width: 80px !important;
    }
}

/* Amélioration de la pagination desktop */
.pagination-container {
    background: white;
    border-radius: 8px;
    padding: 1rem;
    margin-top: 1.5rem;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.pagination-info {
    font-size: 0.875rem;
    color: #6c757d;
}

.pagination-controls {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-wrap: wrap;
}

.page-size-selector {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.page-size-selector select {
    width: 70px;
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
    border: 1px solid #dee2e6;
}

/* Version mobile/tablette de la pagination simplifiée - 375px style */
.mobile-pagination-simple {
    display: none;
    align-items: center;
    justify-content: center;
    gap: 1.5rem;
    padding: 0.75rem 1rem;
    background: white;
    border-radius: 8px;
    margin-top: 1rem;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    max-width: 375px;
    margin-left: auto;
    margin-right: auto;
}

.mobile-pagination-simple .page-indicator {
    font-size: 0.875rem;
    font-weight: 500;
    color: #495057;
    background: #f8f9fa;
    padding: 0.375rem 0.75rem;
    border-radius: 20px;
    min-width: 100px;
    text-align: center;
}

.mobile-pagination-simple .btn {
    min-width: 44px;
    border-radius: 8px;
}

/* Styles pour le modal de réception en mobile/tablette */
@media (max-width: 1024px) {
    .reception-modal .modal-dialog {
        margin: 0;
        height: 100%;
    }
    
    .reception-modal .modal-content {
        min-height: 100vh;
        border-radius: 0;
    }
    
    .reception-modal .modal-body {
        padding: 0.75rem;
    }
    
    .reception-card {
        margin-bottom: 0.75rem;
    }
    
    .reception-card .card-body {
        padding: 0.75rem;
    }
    
    .quantity-input-mobile {
        font-size: 18px !important;
        padding: 0.5rem !important;
        text-align: center;
    }
    
    /* Masquer la version desktop du modal de réception sur tablette/mobile */
    .desktop-reception {
        display: none !important;
    }
    
    /* Afficher la version mobile du modal de réception sur tablette/mobile */
    .mobile-reception {
        display: block !important;
    }
    
    /* Masquer la version desktop du modal de détails sur tablette/mobile */
    .desktop-details {
        display: none !important;
    }
    
    /* Afficher la version mobile du modal de détails sur tablette/mobile */
    .mobile-details {
        display: block !important;
    }
}

@media (min-width: 1025px) {
    .desktop-reception {
        display: block !important;
    }
    
    .mobile-reception {
        display: none !important;
    }
    
    .desktop-details {
        display: block !important;
    }
    
    .mobile-details {
        display: none !important;
    }
}
`;

// Interfaces
interface Supplier {
    rowid: string;
    nom: string;
    code_fournisseur?: string;
    address?: string;
    email?: string;
    phone?: string;
    zip?: string | null;
    town?: string | null;
}

interface OrderLine {
    line_id: string;
    order_id: string;
    order_ref: string;
    order_date: string;
    order_status: number;
    supplier_id: string;
    supplier_name: string;
    supplier_code: string;
    supplier_address: string;
    supplier_phone: string;
    supplier_email: string;
    product_id: string;
    product_ref: string;
    product_label: string;
    product_barcode: string;
    description: string;
    qty_ordered: number;
    qty_remaining: number;
    qty_to_receive: number;
    unit_price: number;
    total_ht: number;
    vat_rate: number;
    discount_percent: number;
    pickupstat: number;
    pickupqty: number;
    datepickup?: string;
}

interface ReceptionModalData {
    lines: OrderLine[];
    order_ref: string;
    supplier_name: string;
    order_id: string;
}

interface SmartPaginationProps {
    currentPage: number;
    totalPages: number;
    totalCount: number;
    countPerPage: number;
    onPageChange: (page: number) => void;
    onPageSizeChange?: (size: number) => void;
    loading: boolean;
}

// Composant de pagination amélioré
const SmartPagination: React.FC<SmartPaginationProps> = ({
    currentPage,
    totalPages,
    totalCount,
    countPerPage,
    onPageChange,
    onPageSizeChange,
    loading
}) => {
    const [pageInput, setPageInput] = useState(currentPage.toString());

    useEffect(() => {
        setPageInput(currentPage.toString());
    }, [currentPage]);

    const handlePageJump = () => {
        const newPage = parseInt(pageInput);
        if (!isNaN(newPage)) {
            const clampedPage = Math.max(1, Math.min(totalPages, newPage));
            onPageChange(clampedPage);
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            handlePageJump();
        }
    };

    // Calculer les pages à afficher
    const getPageNumbers = (): (number | string)[] => {
        const delta = 2;
        const range: number[] = [];
        const rangeWithDots: (number | string)[] = [];
        let l: number | undefined;

        for (let i = 1; i <= totalPages; i++) {
            if (i === 1 || i === totalPages || (i >= currentPage - delta && i <= currentPage + delta)) {
                range.push(i);
            }
        }

        range.forEach((i) => {
            if (l !== undefined) {
                if (i - l === 2) {
                    rangeWithDots.push(l + 1);
                } else if (i - l !== 1) {
                    rangeWithDots.push('...');
                }
            }
            rangeWithDots.push(i);
            l = i;
        });

        return rangeWithDots;
    };

    return (
        <>
            {/* Version desktop */}
            <div className="pagination-container">
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
                    <div className="pagination-info">
                        <i className="ri-information-line me-1"></i>
                        Affichage de <strong>{((currentPage - 1) * countPerPage) + 1}</strong> à{" "}
                        <strong>{Math.min(currentPage * countPerPage, totalCount)}</strong> sur{" "}
                        <strong>{totalCount}</strong> ligne(s)
                    </div>

                    <div className="pagination-controls">
                       

                        <div className="btn-group btn-group-sm">
                            <Button
                                color="light"
                                disabled={currentPage === 1 || loading}
                                onClick={() => onPageChange(1)}
                                title="Première page"
                            >
                                <i className="ri-skip-back-line"></i>
                            </Button>
                            <Button
                                color="light"
                                disabled={currentPage === 1 || loading}
                                onClick={() => onPageChange(currentPage - 1)}
                                title="Page précédente"
                            >
                                <i className="ri-arrow-left-s-line"></i>
                            </Button>
                        </div>

                        <div className="d-none d-sm-flex gap-1">
                            {getPageNumbers().map((page, index) => (
                                page === '...' ? (
                                    <span key={`dots-${index}`} className="px-2 py-1">...</span>
                                ) : (
                                    <Button
                                        key={page}
                                        color={currentPage === page ? "primary" : "light"}
                                        size="sm"
                                        onClick={() => onPageChange(page as number)}
                                        disabled={loading}
                                        style={{ minWidth: '35px' }}
                                    >
                                        {page}
                                    </Button>
                                )
                            ))}
                        </div>

                        <div className="btn-group btn-group-sm">
                            <Button
                                color="light"
                                disabled={currentPage === totalPages || loading}
                                onClick={() => onPageChange(currentPage + 1)}
                                title="Page suivante"
                            >
                                <i className="ri-arrow-right-s-line"></i>
                            </Button>
                            <Button
                                color="light"
                                disabled={currentPage === totalPages || loading}
                                onClick={() => onPageChange(totalPages)}
                                title="Dernière page"
                            >
                                <i className="ri-skip-forward-line"></i>
                            </Button>
                        </div>

                        <div className="d-flex align-items-center gap-1">
                            <Input
                                type="number"
                                min="1"
                                max={totalPages}
                                value={pageInput}
                                onChange={(e) => setPageInput(e.target.value)}
                                onKeyDown={handleKeyDown}
                                style={{ width: '70px' }}
                                className="text-center form-control-sm"
                                disabled={loading}
                            />
                            <Button
                                color="primary"
                                size="sm"
                                onClick={handlePageJump}
                                disabled={loading}
                            >
                                {loading ? <Spinner size="sm" /> : 'Aller'}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Version mobile/tablette simplifiée - sans flèches ni sélecteur de lignes */}
            <div className="mobile-pagination-simple">
                <Button
                    color="light"
                    size="sm"
                    disabled={currentPage === 1 || loading}
                    onClick={() => onPageChange(currentPage - 1)}
                >
                    <i className="ri-arrow-left-s-line"></i>
                </Button>
                <span className="page-indicator">
                    {currentPage} / {totalPages}
                </span>
                <Button
                    color="light"
                    size="sm"
                    disabled={currentPage === totalPages || loading}
                    onClick={() => onPageChange(currentPage + 1)}
                >
                    <i className="ri-arrow-right-s-line"></i>
                </Button>
            </div>
        </>
    );
};

// Carte produit pour vue mobile/tablette
const MobileOrderCard: React.FC<{ order: OrderLine; onDetails: () => void; onReceive: () => void; loading: boolean }> = ({
    order,
    onDetails,
    onReceive,
    loading
}) => {
    const hasPickup = order.pickupstat === 1;
    const qtyToReceive = Math.max(0, order.qty_ordered - (order.pickupqty || 0));

    return (
        <Card className="mb-3 shadow-sm">
            <CardBody className="p-3">
                <div className="d-flex justify-content-between align-items-start mb-2">
                    <div>
                        <h6 className="mb-1 text-primary">
                            <i className="ri-barcode-line me-1"></i>
                            {order.order_ref}
                        </h6>
                        <small className="text-muted">
                            <i className="ri-building-line me-1"></i>
                            {order.supplier_name}
                        </small>
                    </div>
                    {hasPickup ? (
                        <Badge color="success" pill>
                            <i className="ri-check-line me-1"></i>
                            Récupéré
                        </Badge>
                    ) : (
                        qtyToReceive === 0 && (
                            <Badge color="danger" pill>
                                Complet
                            </Badge>
                        )
                    )}
                </div>

                <div className="border-top pt-2 mt-2">
                    <div className="mb-2">
                        <div className="fw-semibold">{order.product_label}</div>
                        <small className="text-muted">{order.product_ref}</small>
                        {order.product_barcode && (
                            <small className="text-muted d-block">
                                Code: {order.product_barcode}
                            </small>
                        )}
                    </div>

                    <div className="row g-2 mb-3">
                        <div className="col-4 text-center">
                            <div className="p-2 bg-light rounded">
                                <div className="small text-muted">Commandée</div>
                                <div className="fw-bold">{order.qty_ordered}</div>
                            </div>
                        </div>
                        <div className="col-4 text-center">
                            <div className="p-2 bg-light rounded">
                                <div className="small text-muted">Déjà reçue</div>
                                <div className="fw-bold text-success">{order.pickupqty || 0}</div>
                            </div>
                        </div>
                        <div className="col-4 text-center">
                            <div className="p-2 bg-light rounded">
                                <div className="small text-muted">À recevoir</div>
                                <div className={`fw-bold ${qtyToReceive === 0 ? 'text-danger' : 'text-warning'}`}>
                                    {qtyToReceive}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex gap-2">
                        <Button
                            color="info"
                            size="sm"
                            onClick={onDetails}
                            className="flex-grow-1"
                        >
                            <i className="ri-eye-line me-1"></i>
                            Détails
                        </Button>
                        {!hasPickup && qtyToReceive > 0 && (
                            <Button
                                color="primary"
                                size="sm"
                                onClick={onReceive}
                                disabled={loading}
                                className="flex-grow-1"
                            >
                                <i className="ri-truck-line me-1"></i>
                                Récupérer
                            </Button>
                        )}
                    </div>
                </div>
            </CardBody>
        </Card>
    );
};

// Carte produit pour le modal de réception en mobile/tablette
const ReceptionProductCard: React.FC<{
    line: OrderLine;
    quantity: number;
    onQuantityChange: (lineId: string, value: string) => void;
    disabled: boolean;
}> = ({ line, quantity, onQuantityChange, disabled }) => {
    const maxQty = Math.max(0, line.qty_ordered - (line.pickupqty || 0));

    return (
        <Card className="reception-card mb-3 shadow-sm">
            <CardBody className="p-3">
                <div className="mb-3 pb-2 border-bottom">
                    <div className="fw-semibold text-primary mb-1">
                        <i className="ri-box-3-line me-1"></i>
                        {line.product_ref}
                    </div>
                    <div className="small text-muted">{line.product_label}</div>
                    {line.product_barcode && (
                        <div className="small text-muted mt-1">
                            <i className="ri-barcode-line me-1"></i>
                            {line.product_barcode}
                        </div>
                    )}
                </div>

                <div className="d-flex gap-2">
                    <div className="flex-1 text-center p-2 bg-light rounded" style={{ flex: 1 }}>
                        <div className="small text-muted mb-1">Commandée</div>
                        <div className="fw-bold fs-5">{line.qty_ordered}</div>
                    </div>
                    <div className="flex-1 text-center p-2 bg-light rounded" style={{ flex: 1 }}>
                        <div className="small text-muted mb-1">Déjà reçue</div>
                        <div className="fw-bold fs-5 text-success">{line.pickupqty || 0}</div>
                    </div>
                    <div className="flex-1 text-center p-2 bg-light rounded" style={{ flex: 0.5 }}>
                        <div className="small text-muted mb-1">À récupérer</div>
                        <Input
                            type="number"
                            min="0"
                            max={maxQty}
                            value={quantity !== undefined ? quantity : maxQty}
                            onChange={(e) => onQuantityChange(line.line_id, e.target.value)}
                            className="text-center fw-bold fs-5"
                            style={{ fontSize: '15px', width: '60%' }}
                            disabled={disabled}
                        />
                    </div>
                </div>
            </CardBody>
        </Card>
    );
};

// Carte pour les détails en mobile/tablette
const DetailsProductCard: React.FC<{ line: OrderLine }> = ({ line }) => {
    return (
        <Card className="mb-3 shadow-sm">
            <CardBody className="p-3">
                <div className="mb-3 pb-2 border-bottom">
                    <div className="fw-semibold text-primary mb-1">
                        <i className="ri-box-3-line me-1"></i>
                        {line.product_ref}
                    </div>
                    <div className="small text-muted">{line.product_label}</div>
                    {line.product_barcode && (
                        <div className="small text-muted mt-1">
                            <i className="ri-barcode-line me-1"></i>
                            {line.product_barcode}
                        </div>
                    )}
                </div>

                <div className="row g-2 mb-3">
                    <div className="col-4">
                        <div className="text-center p-2 bg-light rounded">
                            <div className="small text-muted mb-1">Commandée</div>
                            <div className="fw-bold fs-5">{line.qty_ordered}</div>
                        </div>
                    </div>
                    <div className="col-4">
                        <div className="text-center p-2 bg-light rounded">
                            <div className="small text-muted mb-1">Reçue</div>
                            <div className="fw-bold fs-5 text-success">{line.pickupqty || 0}</div>
                        </div>
                    </div>
                    <div className="col-4">
                        <div className="text-center p-2 bg-light rounded">
                            <div className="small text-muted mb-1">Reste</div>
                            <div className="fw-bold fs-5 text-warning">
                                {Math.max(0, line.qty_ordered - (line.pickupqty || 0))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="text-center">
                    {line.pickupstat === 1 ? (
                        <Badge color="success" className="px-3 py-2 w-100">
                            <i className="ri-check-line me-1"></i>
                            Récupéré
                        </Badge>
                    ) : (
                        <Badge color="warning" className="px-3 py-2 w-100">
                            <i className="ri-time-line me-1"></i>
                            En attente de réception
                        </Badge>
                    )}
                </div>
            </CardBody>
        </Card>
    );
};

const ReceptionsPage = () => {
    const { user } = useAuth();
    const [orderLines, setOrderLines] = useState<OrderLine[]>([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    // Modification: Détection de la taille d'écran pour définir le nombre de lignes par page
    const getInitialLimit = () => {
        if (typeof window !== 'undefined') {
            return window.innerWidth <= 1024 ? 30 : 100;
        }
        return 100; // Valeur par défaut pour SSR
    };
    const [limit, setLimit] = useState(getInitialLimit);
    const [searchOrderRef, setSearchOrderRef] = useState("");
    const [searchProductRef, setSearchProductRef] = useState("");
    const [searchSupplier, setSearchSupplier] = useState("");
    const [searchAll, setSearchAll] = useState("");
    const [supplierId, setSupplierId] = useState<string | null>(null);
    const [totalCount, setTotalCount] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [countPerPage, setCountPerPage] = useState(0);
    const [receptionModalOpen, setReceptionModalOpen] = useState(false);
    const [receptionModalData, setReceptionModalData] = useState<ReceptionModalData | null>(null);
    const [quantities, setQuantities] = useState<{ [key: string]: number }>({});
    const [receptionLoading, setReceptionLoading] = useState(false);
    const [suppliers, setSuppliers] = useState<Supplier[]>([]);
    const [filteredSuppliers, setFilteredSuppliers] = useState<Supplier[]>([]);
    const [showSupplierList, setShowSupplierList] = useState(false);
    const [selectedSupplierName, setSelectedSupplierName] = useState("");
    const [loadingFournisseurs, setLoadingFournisseurs] = useState(false);
    const [mobileFiltersVisible, setMobileFiltersVisible] = useState(false);
    const [detailsModalOpen, setDetailsModalOpen] = useState(false);
    const [detailsModalData, setDetailsModalData] = useState<ReceptionModalData | null>(null);
    const [hideReceivedOrders, setHideReceivedOrders] = useState(true);

    // Modification: Écouter les changements de taille d'écran pour ajuster le nombre de lignes par page
    useEffect(() => {
        const handleResize = () => {
            const newLimit = window.innerWidth <= 1024 ? 30 : 100;
            if (newLimit !== limit) {
                setLimit(newLimit);
                setPage(1); // Réinitialiser à la première page quand le nombre de lignes change
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [limit]);

    const fetchFournisseursData = useCallback(async () => {
        try {
            setLoadingFournisseurs(true);

            const response = await fetch('https://api.apapiecesauto.fr/apiV2/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user.token}`
                },
                body: JSON.stringify({
                    action: "getDataFournisseurs",
                    entity: user.entity
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }

            const data = await response.json();

            if (!data.success) {
                throw new Error(data.message || "Échec du chargement des fournisseurs");
            }

            const fournisseurs = data.fournisseurs || [];
            setSuppliers(fournisseurs);
            setFilteredSuppliers(fournisseurs);

        } catch (err: any) {
            console.error("Error fetching fournisseurs data:", err);
        } finally {
            setLoadingFournisseurs(false);
        }
    }, [user.token, user.entity]);

    const fetchOrderLines = useCallback(async () => {
        setLoading(true);

        try {
            const payload: any = {
                action: 'pickups',
                entity: user.entity,
                page: page,
                limit: limit,
                search_order_ref: searchOrderRef,
                search_product_ref: searchProductRef,
                search_all: searchAll
            };

            if (supplierId) {
                payload.socid = supplierId;
            } else if (searchSupplier) {
                payload.search_supplier = searchSupplier;
            }

            const response = await axios.post(
                'https://api.apapiecesauto.fr/apiV2/',
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${user.token}`,
                    }
                }
            );

            let orderLinesData: OrderLine[] = [];
            let totalRecords = 0;
            let totalPagesValue = 1;
            let currentCount = 0;

            if (response.data && typeof response.data === 'object') {
                if (response.data.data && Array.isArray(response.data.data)) {
                    orderLinesData = response.data.data as OrderLine[];
                    totalRecords = response.data.nbtotalofrecords || response.data.total || 0;
                    totalPagesValue = response.data.totalpages || 1;
                    currentCount = response.data.count || response.data.data.length;
                }
                else if (Array.isArray(response.data)) {
                    orderLinesData = response.data as OrderLine[];
                    currentCount = response.data.length;
                    totalRecords = (response as any).nbtotalofrecords || response.data.length;
                    totalPagesValue = (response as any).totalpages || 1;
                }
            }

            setOrderLines(orderLinesData);
            setTotalCount(totalRecords);
            setTotalPages(totalPagesValue);
            setCountPerPage(currentCount);

            const initialQuantities: { [key: string]: number } = {};
            orderLinesData.forEach((line: OrderLine) => {
                const qtyToReceive = Math.max(0, line.qty_ordered - (line.pickupqty || 0));
                initialQuantities[line.line_id] = qtyToReceive > 0 ? qtyToReceive : 0;
            });
            setQuantities(initialQuantities);

        } catch (error: any) {
            console.error('Error fetching order lines:', error);
            setOrderLines([]);
            setTotalCount(0);
            setTotalPages(1);
            setCountPerPage(0);
            setQuantities({});
        } finally {
            setLoading(false);
        }
    }, [user.entity, user.token, page, limit, searchOrderRef, searchProductRef, searchAll, supplierId, searchSupplier]);

    const handleSelectSupplier = (supplier: Supplier) => {
        setSupplierId(supplier.rowid);
        setSelectedSupplierName(supplier.nom);
        setSearchSupplier(supplier.nom);
        setShowSupplierList(false);
        setMobileFiltersVisible(false);
    };

    const handleClearSupplier = () => {
        setSupplierId(null);
        setSelectedSupplierName("");
        setSearchSupplier("");
        setShowSupplierList(false);
        setFilteredSuppliers(suppliers);
    };

    const handleSupplierSearch = (value: string) => {
        setSearchSupplier(value);
        setSelectedSupplierName("");
        setSupplierId(null);

        if (value.trim() === "") {
            setFilteredSuppliers(suppliers);
        } else {
            const filtered = suppliers.filter(supplier =>
                supplier.nom.toLowerCase().includes(value.toLowerCase()) ||
                (supplier.code_fournisseur && supplier.code_fournisseur.toLowerCase().includes(value.toLowerCase())) ||
                (supplier.email && supplier.email.toLowerCase().includes(value.toLowerCase())) ||
                (supplier.phone && supplier.phone.includes(value))
            );
            setFilteredSuppliers(filtered);
        }
        setShowSupplierList(true);
    };

    const handlePageSizeChange = (newLimit: number) => {
        setLimit(newLimit);
        setPage(1);
    };

    const handleSearch = (e: React.FormEvent) => {
        e.preventDefault();
        setPage(1);
        setMobileFiltersVisible(false);
    };

    const handlePageChange = (newPage: number) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setPage(newPage);
        }
    };

    const handleOpenReceptionModal = (orderRef: string, supplierName: string) => {
        const linesForThisOrder = orderLines.filter(line => line.order_ref === orderRef);
        if (linesForThisOrder.length === 0) return;

        const initialQuantitiesModal: { [key: string]: number } = {};
        linesForThisOrder.forEach((line: OrderLine) => {
            const qtyToReceive = Math.max(0, line.qty_ordered - (line.pickupqty || 0));
            initialQuantitiesModal[line.line_id] = qtyToReceive > 0 ? qtyToReceive : 0;
        });
        setQuantities(initialQuantitiesModal);

        setReceptionModalData({
            lines: linesForThisOrder,
            order_ref: orderRef,
            supplier_name: supplierName,
            order_id: linesForThisOrder[0]?.order_id || ""
        });
        setReceptionModalOpen(true);
    };

    const handleOpenDetailsModal = (orderRef: string, supplierName: string) => {
        const linesForThisOrder = orderLines.filter(line => line.order_ref === orderRef);
        if (linesForThisOrder.length === 0) return;

        setDetailsModalData({
            lines: linesForThisOrder,
            order_ref: orderRef,
            supplier_name: supplierName,
            order_id: linesForThisOrder[0]?.order_id || ""
        });
        setDetailsModalOpen(true);
    };

    const handleQuantityChange = (lineId: string, value: string) => {
        const qty = parseFloat(value) || 0;
        setQuantities(prev => ({
            ...prev,
            [lineId]: qty
        }));
    };

    const validatePickup = async () => {
        if (!receptionModalData) return;
        setReceptionLoading(true);

        try {
            const linesToValidate = receptionModalData.lines.map(line => ({
                line_id: line.line_id,
                qty_received: quantities[line.line_id] || 0
            }));

            const userId = user?.userinfo?.id;
            if (!userId) return;

            const numericUserId = parseInt(userId, 10);
            if (isNaN(numericUserId)) return;

            const response = await axios.post(
                'https://api.apapiecesauto.fr/apiV2/',
                {
                    action: 'validatePickup',
                    entity: user.entity,
                    user_id: numericUserId,
                    order_id: receptionModalData.order_id,
                    lines: linesToValidate
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${user.token}`,
                    },
                    timeout: 30000
                }
            );

            let success = false;
            if (response.data) {
                if (Array.isArray(response.data)) {
                    success = true;
                }
                else if (response.data && typeof response.data === 'object') {
                    if (response.data.success !== undefined) {
                        success = response.data.success === true || response.data.success === "true";
                    }
                    else if (!response.data.error && !response.data.message) {
                        success = true;
                    }
                }
                else {
                    success = true;
                }
            }

            if (success) {
                await fetchOrderLines();
                setReceptionModalOpen(false);
                setReceptionModalData(null);
                setQuantities({});
            }
        } catch (error: any) {
            console.error('Error validating reception:', error);
        } finally {
            setReceptionLoading(false);
        }
    };

    const clearAllFilters = () => {
        setSearchOrderRef("");
        setSearchProductRef("");
        setSearchSupplier("");
        setSearchAll("");
        setSupplierId(null);
        setSelectedSupplierName("");
        setPage(1);
        setMobileFiltersVisible(false);
    };

    const columns = [
        {
            header: "Commande",
            accessorKey: "order_ref",
            cell: (cell: any) => (
                <div className="fw-semibold px-1 text-truncate">
                    {cell.getValue()}
                </div>
            ),
            size: 90,
        },
        {
            header: "Fournisseur",
            accessorKey: "supplier_name",
            cell: (cell: any) => (
                <div className="px-1">
                    <div className="fw-medium text-truncate">
                        {cell.getValue()}
                    </div>
                </div>
            ),
            size: 90,
        },
        {
            header: "Produit",
            accessorKey: "product_ref",
            cell: (cell: any) => {
                const row = cell.row.original;
                return (
                    <div className="px-1">
                        <div className="fw-medium text-truncate" title={row.product_label}>
                            {row.product_label}
                        </div>
                        <div className="small text-muted text-truncate" title={row.product_ref}>
                            {row.product_ref}
                        </div>
                    </div>
                );
            },
            size: 90,
        },
        {
            header: "Qt commandée",
            accessorKey: "qty_ordered",
            cell: (cell: any) => {
                const row = cell.row.original;
                return (
                    <div className="text-center px-1">
                        <div className="fw-bold">{row.qty_ordered}</div>
                    </div>
                );
            },
            size: 80,
        },
        {
            header: "Qt à Récupérer",
            accessorKey: "qty_to_receive",
            cell: (cell: any) => {
                const row = cell.row.original;
                const qtyToReceive = Math.max(0, row.qty_ordered - (row.pickupqty || 0));
                return (
                    <div className="text-center px-1">
                        <div className={`fw-bold ${qtyToReceive === 0 ? 'text-danger' : 'text-warning'}`}>
                            {qtyToReceive}
                        </div>
                    </div>
                );
            },
            size: 80,
        },
        {
            header: "Qt déjà récupérée",
            accessorKey: "pickupqty",
            cell: (cell: any) => {
                const row = cell.row.original;
                return (
                    <div className="text-center px-1">
                        <div className={`fw-bold ${row.pickupqty === 0 ? 'text-muted' : 'text-success'}`}>
                            {row.pickupqty || 0}
                        </div>
                    </div>
                );
            },
            size: 80,
        },
        {
            header: "Action",
            accessorKey: "line_id",
            cell: (cell: any) => {
                const row = cell.row.original;
                const hasPickup = row.pickupstat === 1;
                const qtyToReceive = Math.max(0, row.qty_ordered - (row.pickupqty || 0));
                return (
                    <div className="d-flex justify-content-center px-3 gap-2">
                        <Button
                            color="info"
                            size="sm"
                            onClick={() => handleOpenDetailsModal(row.order_ref, row.supplier_name)}
                        >
                            <i className="ri-eye-line me-1"></i>
                            Détails
                        </Button>
                        {!hasPickup ? (
                            <Button
                                color="primary"
                                size="sm"
                                onClick={() => handleOpenReceptionModal(row.order_ref, row.supplier_name)}
                                disabled={loading || qtyToReceive === 0}
                            >
                                <i className="ri-truck-line me-1"></i>
                                Récupérer
                            </Button>
                        ) : (
                            <Badge color="success" className="d-flex align-items-center px-3">
                                <i className="ri-check-line me-1"></i>
                                Déjà Récupéré
                            </Badge>
                        )}
                    </div>
                );
            },
            size: 90,
        }
    ];

    useEffect(() => {
        fetchOrderLines();
        fetchFournisseursData();
    }, [fetchOrderLines, fetchFournisseursData]);

    const totalQuantityToReceive = receptionModalData?.lines.reduce((sum, line) =>
        sum + (quantities[line.line_id] !== undefined ? quantities[line.line_id] : Math.max(0, line.qty_ordered - (line.pickupqty || 0))), 0
    ) || 0;

    // Une ligne est "réceptionnée en entier" quand toute la quantité commandée
    // a déjà été récupérée du fournisseur (qty_ordered - pickupqty <= 0).
    const visibleOrderLines = hideReceivedOrders
        ? orderLines.filter((line) => (line.qty_ordered - (line.pickupqty || 0)) > 0)
        : orderLines;
    const hiddenReceivedCount = orderLines.length - visibleOrderLines.length;

    return (
        <div className="page-content">
            <style>{responsiveStyles}</style>

            <Container fluid>
                <Row>
                    <Col lg={12}>
                        <Card>
                            <CardBody>
                                <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-2 mb-3">
                                    <h4 className="card-title mb-0">Commandes à Récupérer</h4>
                                    <div className="text-muted small">
                                        Total: <strong>{totalCount}</strong> commande(s)
                                    </div>
                                </div>

                                {/* Version desktop des filtres */}
                                <form onSubmit={handleSearch} className="desktop-filters mb-4">
                                    <Row className="g-3 align-items-end">
                                        <Col md={3}>
                                            <FormGroup className="mb-0">
                                                <Label className="form-label fw-semibold small text-muted mb-1">
                                                    RÉF. COMMANDE
                                                </Label>
                                                <InputGroup>
                                                    <InputGroupText className="bg-light border-end-0">
                                                        <i className="ri-barcode-line"></i>
                                                    </InputGroupText>
                                                    <Input
                                                        type="text"
                                                        placeholder="Rechercher..."
                                                        value={searchOrderRef}
                                                        onChange={(e) => setSearchOrderRef(e.target.value)}
                                                        className="border-start-0"
                                                        style={{ height: "42px" }}
                                                    />
                                                </InputGroup>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3}>
                                            <FormGroup className="mb-0">
                                                <Label className="form-label fw-semibold small text-muted mb-1">
                                                    RÉF. PRODUIT
                                                </Label>
                                                <InputGroup>
                                                    <InputGroupText className="bg-light border-end-0">
                                                        <i className="ri-box-3-line"></i>
                                                    </InputGroupText>
                                                    <Input
                                                        type="text"
                                                        placeholder="Référence produit..."
                                                        value={searchProductRef}
                                                        onChange={(e) => setSearchProductRef(e.target.value)}
                                                        className="border-start-0"
                                                        style={{ height: "42px" }}
                                                    />
                                                </InputGroup>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3}>
                                            <FormGroup className="mb-0">
                                                <Label className="form-label fw-semibold small text-muted mb-1">
                                                    FOURNISSEUR
                                                </Label>
                                                <div className="position-relative">
                                                    <InputGroup>
                                                        <InputGroupText className="bg-light border-end-0">
                                                            <i className="ri-building-line"></i>
                                                        </InputGroupText>
                                                        <Input
                                                            type="text"
                                                            placeholder={loadingFournisseurs ? "Chargement..." : "Sélectionner..."}
                                                            value={selectedSupplierName || searchSupplier}
                                                            onChange={(e) => handleSupplierSearch(e.target.value)}
                                                            onFocus={() => setShowSupplierList(true)}
                                                            onBlur={() => setTimeout(() => setShowSupplierList(false), 200)}
                                                            className="border-start-0"
                                                            style={{ height: "42px" }}
                                                            disabled={loadingFournisseurs}
                                                        />
                                                        {(selectedSupplierName || searchSupplier) && !loadingFournisseurs && (
                                                            <Button
                                                                color="light"
                                                                onClick={handleClearSupplier}
                                                                className="border-0 text-muted"
                                                                type="button"
                                                            >
                                                                <i className="ri-close-line"></i>
                                                            </Button>
                                                        )}
                                                    </InputGroup>

                                                    {showSupplierList && filteredSuppliers.length > 0 && !loadingFournisseurs && (
                                                        <div className="position-absolute w-100 border shadow-lg bg-white mt-1 rounded"
                                                            style={{ zIndex: 1000, maxHeight: "300px", overflowY: "auto" }}>
                                                            <div className="p-2">
                                                                {filteredSuppliers.map((supplier) => (
                                                                    <div
                                                                        key={supplier.rowid}
                                                                        onClick={() => handleSelectSupplier(supplier)}
                                                                        className="py-2 px-3 border-bottom cursor-pointer">
                                                                        <div className="fw-semibold text-primary">
                                                                            {supplier.nom}
                                                                        </div>
                                                                        {supplier.code_fournisseur && (
                                                                            <div className="small text-muted">
                                                                                {supplier.code_fournisseur}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="d-flex align-items-end">
                                            <FormGroup className="mb-0 w-100">
                                                <Label className="form-label fw-semibold small text-muted mb-1 d-block invisible">
                                                    &nbsp;
                                                </Label>
                                                <div className="d-flex gap-2" style={{ height: "42px" }}>
                                                    <Button
                                                        type="submit"
                                                        color="primary"
                                                        className="flex-grow-1"
                                                        style={{
                                                            height: "100%",
                                                            width: "calc(100% - 58px)",
                                                            maxWidth: "200px"
                                                        }}
                                                        disabled={loading || loadingFournisseurs}
                                                    >
                                                        {loading ? (
                                                            <Spinner size="sm" />
                                                        ) : (
                                                            <>
                                                                <i className="ri-search-line align-bottom me-1"></i>
                                                                Rechercher
                                                            </>
                                                        )}
                                                    </Button>

                                                    <Button
                                                        color="light"
                                                        onClick={clearAllFilters}
                                                        disabled={loading || loadingFournisseurs}
                                                        className="d-flex align-items-center justify-content-center border"
                                                        style={{
                                                            width: "42px",
                                                            padding: "0",
                                                            flexShrink: 0
                                                        }}
                                                        title="Effacer tous les filtres"
                                                    >
                                                        <i className="ri-filter-off-line"></i>
                                                    </Button>
                                                </div>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </form>

                                {/* Version mobile/tablette des filtres */}
                                <div className="mobile-filters mb-3">
                                    <Button color="light" onClick={() => setMobileFiltersVisible(!mobileFiltersVisible)} className="w-100 mb-2">
                                        <i className={`ri-${mobileFiltersVisible ? 'close' : 'filter'}-line me-2`}></i>
                                        {mobileFiltersVisible ? 'Fermer les filtres' : 'Afficher les filtres'}
                                    </Button>

                                    {mobileFiltersVisible && (
                                        <div className="border rounded p-3 bg-light">
                                            <div className="mb-3">
                                                <Label className="small text-muted mb-1">RÉF. COMMANDE</Label>
                                                <Input type="text" placeholder="Référence commande..." value={searchOrderRef} onChange={(e) => setSearchOrderRef(e.target.value)} />
                                            </div>
                                            <div className="mb-3">
                                                <Label className="small text-muted mb-1">RÉF. PRODUIT</Label>
                                                <Input type="text" placeholder="Référence produit..." value={searchProductRef} onChange={(e) => setSearchProductRef(e.target.value)} />
                                            </div>
                                            <div className="mb-3">
                                                <Label className="small text-muted mb-1">FOURNISSEUR</Label>
                                                <Input type="text" placeholder="Sélectionner..." value={selectedSupplierName || searchSupplier} onChange={(e) => handleSupplierSearch(e.target.value)} />
                                            </div>
                                            <div className="d-flex gap-2">
                                                <Button color="primary" onClick={handleSearch} className="flex-grow-1">Rechercher</Button>
                                                <Button color="light" onClick={clearAllFilters}>Effacer</Button>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className="d-flex flex-wrap align-items-center mb-3">
                                    <FormGroup check className="mb-0">
                                        <Input
                                            type="checkbox"
                                            id="hideReceivedOrders"
                                            checked={hideReceivedOrders}
                                            onChange={(e) => setHideReceivedOrders(e.target.checked)}
                                        />
                                        <Label for="hideReceivedOrders" check className="user-select-none">
                                            Masquer les commandes réceptionnées
                                        </Label>
                                    </FormGroup>
                                    {hideReceivedOrders && hiddenReceivedCount > 0 && (
                                        <small className="text-muted ms-2">
                                            ({hiddenReceivedCount} masquée{hiddenReceivedCount > 1 ? 's' : ''})
                                        </small>
                                    )}
                                </div>

                                {loading && visibleOrderLines.length === 0 ? (
                                    <div className="text-center py-4">
                                        <Spinner color="primary" />
                                        <div className="mt-2">Chargement...</div>
                                    </div>
                                ) : visibleOrderLines.length === 0 ? (
                                    <div className="text-center py-4">
                                        <i className="ri-checkbox-circle-line display-5 text-success"></i>
                                        <h5 className="mt-3">Aucune ligne à récupérer</h5>
                                        {hideReceivedOrders && hiddenReceivedCount > 0 && (
                                            <p className="text-muted">
                                                Toutes les commandes affichables ont été réceptionnées
                                            </p>
                                        )}
                                    </div>
                                ) : (
                                    <>
                                        {/* Vue desktop */}
                                        <div className="desktop-view position-relative">
                                            <div className="table-responsive">
                                                <TableContainer
                                                    columns={columns}
                                                    data={visibleOrderLines}
                                                    isGlobalFilter={false}
                                                    customPageSize={limit}
                                                    divClass="table-responsive"
                                                    tableClass="align-middle table-nowrap"
                                                    theadClass="table-light text-muted"
                                                />
                                            </div>
                                        </div>

                                        {/* Vue mobile/tablette */}
                                        <div className="mobile-view">
                                            {visibleOrderLines.map((order) => (
                                                <MobileOrderCard
                                                    key={order.line_id}
                                                    order={order}
                                                    onDetails={() => handleOpenDetailsModal(order.order_ref, order.supplier_name)}
                                                    onReceive={() => handleOpenReceptionModal(order.order_ref, order.supplier_name)}
                                                    loading={loading}
                                                />
                                            ))}
                                        </div>

                                        <SmartPagination
                                            currentPage={page}
                                            totalPages={totalPages}
                                            totalCount={totalCount}
                                            countPerPage={countPerPage}
                                            onPageChange={handlePageChange}
                                            onPageSizeChange={handlePageSizeChange}
                                            loading={loading}
                                        />
                                    </>
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>

            <Modal
                isOpen={receptionModalOpen}
                toggle={() => setReceptionModalOpen(false)}
                size="lg"
                className="reception-modal"
                fullscreen="md"
            >
                <ModalHeader toggle={() => setReceptionModalOpen(false)}>
                    <div className="d-flex flex-wrap align-items-center gap-2">
                        <i className="ri-truck-line text-primary"></i>
                        <span>Récupérer la commande</span>
                        {receptionModalData && (
                            <>
                                <Badge color="primary">{receptionModalData.order_ref}</Badge>
                                <Badge color="info">{receptionModalData.supplier_name}</Badge>
                            </>
                        )}
                    </div>
                </ModalHeader>
                <ModalBody>
                    {receptionModalData ? (
                        <div>
                            <div className="alert alert-info mb-3 small">
                                <i className="ri-information-line me-2"></i>
                                Vérifiez les quantités à récupérer pour chaque produit.
                            </div>

                            {/* Version desktop du tableau */}
                            <div className="desktop-reception">
                                <div className="table-responsive">
                                    <Table bordered className="mb-0">
                                        <thead className="table-light">
                                            <tr>
                                                <th>Produit</th>
                                                <th className="text-center" style={{ width: '100px' }}>Qtée</th>
                                                <th className="text-center" style={{ width: '100px' }}>Reçue</th>
                                                <th className="text-center" style={{ width: '130px' }}>À récupérer</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {receptionModalData.lines.map((line) => {
                                                const maxQty = Math.max(0, line.qty_ordered - (line.pickupqty || 0));
                                                return (
                                                    <tr key={line.line_id}>
                                                        <td>
                                                            <div className="fw-medium">{line.product_ref}</div>
                                                            <div className="small text-muted">{line.product_label}</div>
                                                        </td>
                                                        <td className="text-center align-middle">
                                                            <span className="fw-bold">{line.qty_ordered}</span>
                                                        </td>
                                                        <td className="text-center align-middle">
                                                            <span className="fw-bold text-success">{line.pickupqty || 0}</span>
                                                        </td>
                                                        <td className="text-center align-middle">
                                                            <div className="d-flex flex-column align-items-center gap-1">
                                                                <Input
                                                                    type="number"
                                                                    min="0"
                                                                    max={maxQty}
                                                                    value={quantities[line.line_id] !== undefined ? quantities[line.line_id] : maxQty}
                                                                    onChange={(e) => handleQuantityChange(line.line_id, e.target.value)}
                                                                    className="text-center"
                                                                    style={{ width: '100px' }}
                                                                    disabled={receptionLoading}
                                                                />
                                                                <small className="text-muted">Max: {maxQty}</small>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </Table>
                                </div>
                            </div>

                            {/* Version mobile/tablette du modal de réception - Cartes */}
                            <div className="mobile-reception">
                                {receptionModalData.lines.map((line) => (
                                    <ReceptionProductCard
                                        key={line.line_id}
                                        line={line}
                                        quantity={quantities[line.line_id]}
                                        onQuantityChange={handleQuantityChange}
                                        disabled={receptionLoading}
                                    />
                                ))}
                            </div>


                        </div>
                    ) : (
                        <div className="text-center py-4">
                            <Spinner color="primary" />
                        </div>
                    )}
                </ModalBody>
                <ModalFooter className="flex-wrap gap-2">
                    <Button color="secondary" onClick={() => setReceptionModalOpen(false)} disabled={receptionLoading} className="flex-grow-1 flex-md-grow-0">
                        <i className="ri-close-line me-1"></i>
                        Annuler
                    </Button>
                    <Button color="primary" onClick={validatePickup} disabled={receptionLoading} className="flex-grow-1 flex-md-grow-0">
                        {receptionLoading ? <><Spinner size="sm" className="me-2" />Validation...</> : <><i className="ri-check-double-line me-1"></i>Valider la réception</>}
                    </Button>
                </ModalFooter>
            </Modal>
            {/* Modal de détails - Version mobile/tablette optimisée */}
            <Modal isOpen={detailsModalOpen} toggle={() => setDetailsModalOpen(false)} size="lg" className="details-modal">
                <ModalHeader toggle={() => setDetailsModalOpen(false)}>
                    <div className="d-flex flex-wrap align-items-center gap-2">
                        <i className="ri-eye-line text-info"></i>
                        <span>Détails de la commande</span>
                        {detailsModalData && (
                            <>
                                <Badge color="primary">{detailsModalData.order_ref}</Badge>
                                <Badge color="info">{detailsModalData.supplier_name}</Badge>
                            </>
                        )}
                    </div>
                </ModalHeader>
                <ModalBody>
                    {detailsModalData ? (
                        <div>
                            {/* Version desktop du tableau */}
                            <div className="desktop-details">
                                <div className="table-responsive">
                                    <Table bordered className="mb-3">
                                        <thead className="table-light">
                                            <tr>
                                                <th>Produit</th>
                                                <th className="text-center" style={{ width: '100px' }}>Commandée</th>
                                                <th className="text-center" style={{ width: '100px' }}>Reçue</th>
                                                <th className="text-center" style={{ width: '100px' }}>Reste</th>
                                                <th className="text-center" style={{ width: '110px' }}>Statut</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {detailsModalData.lines.map((line) => (
                                                <tr key={line.line_id}>
                                                    <td>
                                                        <div className="fw-medium">{line.product_ref}</div>
                                                        <div className="small text-muted">{line.product_label}</div>
                                                        {line.product_barcode && (
                                                            <div className="small text-muted">Code: {line.product_barcode}</div>
                                                        )}
                                                    </td>
                                                    <td className="text-center align-middle">
                                                        <span className="fw-bold">{line.qty_ordered}</span>
                                                    </td>
                                                    <td className="text-center align-middle">
                                                        <span className="fw-bold text-success">{line.pickupqty || 0}</span>
                                                    </td>
                                                    <td className="text-center align-middle">
                                                        <span className="fw-bold text-warning">{Math.max(0, line.qty_ordered - (line.pickupqty || 0))}</span>
                                                    </td>
                                                    <td className="text-center align-middle">
                                                        {line.pickupstat === 1 ? (
                                                            <Badge color="success" className="px-2 py-1">
                                                                <i className="ri-check-line me-1"></i>
                                                                Récupéré
                                                            </Badge>
                                                        ) : (
                                                            <Badge color="warning" className="px-2 py-1">
                                                                <i className="ri-time-line me-1"></i>
                                                                En attente
                                                            </Badge>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            </div>

                            {/* Version mobile/tablette des détails - Cartes */}
                            <div className="mobile-details">
                                {detailsModalData.lines.map((line) => (
                                    <DetailsProductCard key={line.line_id} line={line} />
                                ))}
                            </div>

                            {/* Résumé des informations */}
                            <div className="mt-3 p-3 bg-light rounded">
                                <div className="row">
                                    <div className="col-12 col-md-6 mb-3 mb-md-0">
                                        <h6 className="mb-2">
                                            <i className="ri-information-line me-1"></i>
                                            Informations commande
                                        </h6>
                                        <div className="small">
                                            <div className="mb-1">
                                                <strong>Référence:</strong> {detailsModalData.order_ref}
                                            </div>
                                            <div className="mb-1">
                                                <strong>Fournisseur:</strong> {detailsModalData.supplier_name}
                                            </div>
                                            <div className="mb-1">
                                                <strong>Total produits:</strong> {detailsModalData.lines.length}
                                            </div>
                                            {detailsModalData.lines[0]?.datepickup && (
                                                <div className="mb-1 text-success">
                                                    <strong>Date récupération:</strong> {new Date(detailsModalData.lines[0].datepickup).toLocaleDateString('fr-FR')}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <h6 className="mb-2">
                                            <i className="ri-bar-chart-2-line me-1"></i>
                                            Récapitulatif
                                        </h6>
                                        <div className="small">
                                            <div className="mb-1">
                                                <strong>Quantité totale commandée:</strong>{' '}
                                                {detailsModalData.lines.reduce((sum, line) => sum + line.qty_ordered, 0)}
                                            </div>
                                            <div className="mb-1 text-success">
                                                <strong>Quantité déjà reçue:</strong>{' '}
                                                {detailsModalData.lines.reduce((sum, line) => sum + (line.pickupqty || 0), 0)}
                                            </div>
                                            <div className="mb-1 text-warning">
                                                <strong>Quantité restante à recevoir:</strong>{' '}
                                                {detailsModalData.lines.reduce((sum, line) =>
                                                    sum + Math.max(0, line.qty_ordered - (line.pickupqty || 0)), 0
                                                )}
                                            </div>
                                            <div className="mt-2 pt-2 border-top">
                                                <strong>Taux de réception:</strong>{' '}
                                                <div className="progress mt-1" style={{ height: '8px' }}>
                                                    <div
                                                        className="progress-bar bg-success"
                                                        role="progressbar"
                                                        style={{
                                                            width: `${(detailsModalData.lines.reduce((sum, line) => sum + (line.pickupqty || 0), 0) /
                                                                detailsModalData.lines.reduce((sum, line) => sum + line.qty_ordered, 0)) * 100}%`
                                                        }}
                                                    />
                                                </div>
                                                <small className="text-muted">
                                                    {Math.round((detailsModalData.lines.reduce((sum, line) => sum + (line.pickupqty || 0), 0) /
                                                        detailsModalData.lines.reduce((sum, line) => sum + line.qty_ordered, 0)) * 100)}% reçu
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="text-center py-4">
                            <Spinner color="primary" />
                            <div className="mt-2">Chargement des détails...</div>
                        </div>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setDetailsModalOpen(false)} className="w-100 w-md-auto">
                        <i className="ri-close-line me-1"></i>
                        Fermer
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default ReceptionsPage;